import * as React from 'react';
import { useSelector } from 'react-redux';
import {
    betreuerByNrSelector,
    branchenByNrSelector,
    erweiterteSuchenByNrSelector,
    interesseFuerProdukteByNrSelector,
    produktgruppenByNrSelector,
} from 'store/lookups/selector';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { useKunde } from 'api/kunde';
import moment from 'moment-timezone';
import { RechnungStatusLabel } from 'utils/labels';
import { formStyles } from 'styles/formStyles';
import { FilterValues } from './types';

export const styles = mergeStyleSets({
    filterInfo: {
        marginBottom: 10,
    },
});

interface FilterInfoProps {
    filterValues: FilterValues;
}

export const FilterInfo: React.FC<FilterInfoProps> = ({
    filterValues: {
        statusList,
        kNr,
        konzernNr,
        konzernName,
        kundePlzVon,
        kundePlzBis,
        kundeUmsatzTsdVon,
        kundeUmsatzTsdBis,
        kundeBranchen,
        kundeErweiterteSuchen,
        kundeInteresseFuerProdukte,
        kundeBetreuer,
        kundeTelBetreuer,
        betreuer,
        betreuerGebiet,
        telBetreuer,
        telBetreuerGebiet,
        produktgruppen,
    },
}) => {
    const betreuerByNr = useSelector(betreuerByNrSelector);
    const branchenByNr = useSelector(branchenByNrSelector);
    const interesseFuerProdukteByNr = useSelector(interesseFuerProdukteByNrSelector);
    const erweiterteSuchenByNr = useSelector(erweiterteSuchenByNrSelector);
    const produktgruppenByNr = useSelector(produktgruppenByNrSelector);
    const kunde = useKunde(
        {
            nr: kNr || 0,
        },
        { enabled: !!kNr },
    );

    return (
        <table className={formStyles.reportFilterInfo}>
            <tr>
                <td>Druckdatum: </td>
                <td>{moment().format('DD.MM.YYYY HH:mm:ss')}</td>
            </tr>
            <tr>
                <td>Status:</td>
                <td>{statusList.map((status) => RechnungStatusLabel[status] || status).join(', ')}</td>
            </tr>
            {betreuer && (
                <tr>
                    <td>Betreuer (Rechnung):</td>
                    <td>
                        {betreuerByNr[betreuer]?.name || betreuer} {betreuerGebiet ? ' (nur Gebiet)' : ''}
                    </td>
                </tr>
            )}
            {telBetreuer && (
                <tr>
                    <td>Tel.-Betreuer (Rechnung):</td>
                    <td>
                        {betreuerByNr[telBetreuer]?.name || telBetreuer} {telBetreuerGebiet ? ' (nur Gebiet)' : ''}
                    </td>
                </tr>
            )}
            {produktgruppen && produktgruppen.length > 0 && (
                <tr>
                    <td>Produktgruppen:</td>
                    <td>{produktgruppen.map((nr) => produktgruppenByNr[nr]?.text || nr).join(', ')}</td>
                </tr>
            )}
            {kNr && (
                <tr>
                    <td>Kunde:</td>
                    <td>{kunde.data?.name1}</td>
                </tr>
            )}
            {konzernNr && (
                <tr>
                    <td>Konzern:</td>
                    <td>{konzernName}</td>
                </tr>
            )}
            {kundePlzVon && (
                <tr>
                    <td>PLZ (von):</td>
                    <td>{kundePlzVon}</td>
                </tr>
            )}
            {kundePlzBis && (
                <tr>
                    <td>PLZ (bis):</td>
                    <td>{kundePlzBis}</td>
                </tr>
            )}
            {kundeUmsatzTsdVon ? (
                <tr>
                    <td>Jahresumsatz d. Kunden (von, in TSD):</td>
                    <td>{kundeUmsatzTsdVon}</td>
                </tr>
            ) : (
                ''
            )}
            {kundeUmsatzTsdBis ? (
                <tr>
                    <td>Jahresumsatz d. Kunden (bis, in TSD):</td>
                    <td>{kundeUmsatzTsdBis}</td>
                </tr>
            ) : (
                ''
            )}
            {kundeBetreuer && (
                <tr>
                    <td>Betreuer (Kunde):</td>
                    <td>{betreuerByNr[kundeBetreuer]?.name || betreuer}</td>
                </tr>
            )}
            {kundeTelBetreuer && (
                <tr>
                    <td>Tel.-Betreuer (Kunde):</td>
                    <td>{betreuerByNr[kundeTelBetreuer]?.name || kundeTelBetreuer}</td>
                </tr>
            )}
            {kundeBranchen && kundeBranchen.length > 0 && (
                <tr>
                    <td>Branchen:</td>
                    <td>{kundeBranchen.map((nr) => branchenByNr[nr]?.text || nr).join(', ')}</td>
                </tr>
            )}
            {kundeInteresseFuerProdukte && kundeInteresseFuerProdukte.length > 0 && (
                <tr>
                    <td>Interesse für Produkte:</td>
                    <td>
                        {kundeInteresseFuerProdukte.map((nr) => interesseFuerProdukteByNr[nr]?.text || nr).join(', ')}
                    </td>
                </tr>
            )}
            {kundeErweiterteSuchen && kundeErweiterteSuchen.length > 0 && (
                <tr>
                    <td>Erweiterte Suchen:</td>
                    <td>{kundeErweiterteSuchen.map((nr) => erweiterteSuchenByNr[nr]?.text || nr).join(', ')}</td>
                </tr>
            )}
        </table>
    );
};
